import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { TypeORMError } from "../error";
/**
 * Contains all information about entity's relation count.
 */
export var RelationCountMetadata = /*#__PURE__*/function () {
  // ---------------------------------------------------------------------
  // Constructor
  // ---------------------------------------------------------------------
  function RelationCountMetadata(options) {
    _classCallCheck(this, RelationCountMetadata);
    this.entityMetadata = options.entityMetadata;
    this.target = options.args.target;
    this.propertyName = options.args.propertyName;
    this.relationNameOrFactory = options.args.relation;
    this.alias = options.args.alias;
    this.queryBuilderFactory = options.args.queryBuilderFactory;
  }
  // ---------------------------------------------------------------------
  // Public Builder Methods
  // ---------------------------------------------------------------------
  /**
   * Builds some depend relation count metadata properties.
   * This builder method should be used only after entity metadata, its properties map and all relations are build.
   */
  _createClass(RelationCountMetadata, [{
    key: "build",
    value: function build() {
      var propertyPath = typeof this.relationNameOrFactory === "function" ? this.relationNameOrFactory(this.entityMetadata.propertiesMap) : this.relationNameOrFactory;
      var relation = this.entityMetadata.findRelationWithPropertyPath(propertyPath);
      if (!relation) throw new TypeORMError("Cannot find relation ".concat(propertyPath, ". Wrong relation specified for @RelationCount decorator."));
      this.relation = relation;
    }
  }]);
  return RelationCountMetadata;
}();